import PassengerRoomClass from '../hotel/PassengerRoomClass';

/**
 * DP 宿泊者の部屋単体での管理
 */
export default class DpPassengerRoomClass extends PassengerRoomClass {
  constructor(_target, _index) {
    super(_target, _index);
    this.name = 'DpPassengerRoomClass';
    this.maxNum = 6;
  }

  onError() {
    this.jq.trigger(this.EVENT_ERROR, { msg: LtikeCommon.DP.TEXT.MODAL_PASSENGER_ERROR3, index: this.index, target: this.target });
  }

  onClick_adultMinus() {
    this.jq.trigger(this.EVENT_CHANGE, { index: this.index, adult: -1 });
  }

  onClick_adultPlus() {
    this.jq.trigger(this.EVENT_CHANGE, { index: this.index, adult: 1 });
  }

  onClick_childMinus() {
    this.jq.trigger(this.EVENT_CHANGE, { index: this.index, child: -1 });
  }

  onClick_childPlus() {
    this.jq.trigger(this.EVENT_CHANGE, { index: this.index, child: 1 });
  }

}
